var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.79 21.36C33.3748 19.3416 32.3461 17.5008 30.8448 16.0894C29.3435 14.6779 27.4428 13.7647 25.4027 13.4747C23.3625 13.1846 21.2826 13.5319 19.4474 14.469C17.6122 15.4062 16.1113 16.8873 15.15 18.71C13.0283 18.8227 11.0382 19.7737 9.61762 21.3537C8.19703 22.9337 7.46228 25.0133 7.575 27.135C7.68771 29.2567 8.63867 31.2468 10.2187 32.6674C11.7987 34.088 13.8783 34.8227 16 34.71H21V30H16L24 22L32 30H27V34.67H33.33C35.0758 34.6997 36.7635 34.0425 38.0296 32.8401C39.2956 31.6376 40.0388 29.986 40.0992 28.241C40.1595 26.4959 39.532 24.797 38.352 23.51C37.172 22.223 35.5337 21.4509 33.79 21.36Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.b93a4b8e.svg";
export { ForwardRef as ReactComponent };